$('.featured-product-slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     dots: true,
     mobileFirst: true,
     autoplay: true,
     autoplaySpeed: 3500,
     speed: 1000,
     slide: '.product-block',
     adaptiveHeight: true,
     responsive: [
        {
           breakpoint: 600,
           settings: "unslick"
        }
     ]
  });

$('.product-image-slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     dots: true,
     mobileFirst: true,
     slide: '.product-media',
     adaptiveHeight: true,
     responsive: [
        {
           breakpoint: 600,
           settings: "unslick"
        }
     ]
  });

$('.product-recommendations-slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     dots: true,
     autoplay: false,
     autoplaySpeed: 2000,
     mobileFirst: true,
     slide: '.product-block',
     adaptiveHeight: true,
     responsive: [
        {
           breakpoint: 600,
           settings: "unslick"
        }
     ]
  });